import { render } from "./IdeaListNewtab.vue?vue&type=template&id=034dacae&scoped=true"
import script from "./IdeaListNewtab.vue?vue&type=script&lang=js"
export * from "./IdeaListNewtab.vue?vue&type=script&lang=js"

import "./IdeaListNewtab.vue?vue&type=style&index=0&id=034dacae&scoped=true&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-034dacae"]])

export default __exports__